module.exports = __webpack_public_path__ + "img/logo1.feb683e8.png";